var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-x grid-padding-x" }, [
    _vm.requiredDocument.id
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.requiredDocument.id,
              expression: "requiredDocument.id"
            }
          ],
          attrs: {
            name: "required_documents[" + _vm.index + "][id]",
            type: "hidden",
            required: ""
          },
          domProps: { value: _vm.requiredDocument.id },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.requiredDocument, "id", $event.target.value)
            }
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.sourceTable,
          expression: "sourceTable"
        }
      ],
      attrs: {
        name: "required_documents[" + _vm.index + "][source_table]",
        type: "hidden",
        required: ""
      },
      domProps: { value: _vm.sourceTable },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.sourceTable = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.sourceField,
          expression: "sourceField"
        }
      ],
      attrs: {
        name: "required_documents[" + _vm.index + "][source_field]",
        type: "hidden",
        required: ""
      },
      domProps: { value: _vm.sourceField },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.sourceField = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    !isNaN(this.documentType)
      ? _c("input", {
          attrs: {
            name: "required_documents[" + _vm.index + "][source_id]",
            type: "hidden"
          },
          domProps: { value: this.documentType }
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "cell small-5" }, [
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.documentType,
              expression: "documentType"
            }
          ],
          attrs: { disabled: _vm.disabled, required: "" },
          on: {
            change: function($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function(o) {
                  return o.selected
                })
                .map(function(o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.documentType = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            }
          }
        },
        [
          _vm._l(_vm.qualificationLevels, function(qualification, index) {
            return [
              _c("option", { domProps: { value: qualification.id } }, [
                _vm._v(_vm._s(qualification.title))
              ])
            ]
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cell small-6 pl-0" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.requiredDocument.title,
            expression: "requiredDocument.title"
          }
        ],
        attrs: {
          disabled: _vm.disabled,
          name: "required_documents[" + _vm.index + "][title]",
          type: "text",
          required: ""
        },
        domProps: { value: _vm.requiredDocument.title },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.$set(_vm.requiredDocument, "title", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cell shrink small-1" }, [
      !_vm.disabled
        ? _c(
            "div",
            {
              staticClass: "remove-button",
              on: {
                click: function() {
                  return _vm.$emit("remove")
                }
              }
            },
            [_c("i", { staticClass: "fas fa-minus-circle" })]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72083944", { render: render, staticRenderFns: staticRenderFns })
  }
}